// extracted by mini-css-extract-plugin
module.exports = {"simulationChooser":"SimulationChooser_simulationChooser__DLI7t","listButtons":"SimulationChooser_listButtons__12SwW"};